import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  FormControl,
  InputLabel,
  TableFooter,
  TablePagination,
  Button,
  IconButton,
  Tooltip,
  Tab,
  Tabs,
} from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { InputTextarea } from "primereact/inputtextarea";
import RulePage from "./RulesPage";
import {
  addRule,
  deleteInstruction,
  getRules,
  updateRule,
} from "../services/managerules.service";
import { useSnackbar } from "../common/SnackbarContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface DataRow {
  payScaleType: string;
  ruleNumber: string;
  name: string;
  description: string;
  priority: number;
}

type Rule = {
  payScaleType: string;
  ruleNumber: string;
  name: string;
  description: string;
  warning?: string;
};

const ValidationRules = (props: any) => {
  console.log(props.data.data);
  const [initialData, setInitialData] = React.useState(props.data.data);
  const [payScaleTypes, setPayScaleTypes] = React.useState(
    props.data.payScaleType
  );
  const [ruleNumbers, setRuleNumbers] = React.useState(props.data.ruleNumber);
  const [ruleno, setRuleno] = useState("");
  //Edit Rule Fields
  const [ruleDescEdit, setRuleDescEdit] = useState("");
  const [ruleIdEdit, setRuleIdEdit] = useState("")
  const [ruleNumberEdit, setRuleNumberEdit] = useState("");
  const [ruleNameEdit, setRuleNameEdit] = useState("");
  const [priorityEdit, setPriorityEdit] = useState("");
  const [payScaleTypeEdit, setPayscaleTypeEdit] = useState("");

  const [ruleDescAdd, setRuleDescAdd] = useState("");
  const [ruleNumberAdd, setRuleNumberAdd] = useState("");
  const [ruleNameAdd, setRuleNameAdd] = useState("");
  const [priorityAdd, setPriorityAdd] = useState("");
  const [payScaleTypeAdd, setPayscaleTypeAdd] = useState("");
  const [delRulNo, setDelRulNo] = useState("");
  const [delPayScaleType, setDelPayScaleType] = useState("");

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const [confirmationDeleteOpen, setConfirmationDeleteOpen] = useState(false);
  const [pendingDeletePayload, setPendingDeletePayload] = useState<any>(null);
  const [confirmationDeleteMessage, setConfirmationDeleteMessage] =
    useState("");

  const [pendingPayload, setPendingPayload] = useState<any>(null);
  const [payScaleError, setPayScaleError] = useState(false);
  const { showSnackbar } = useSnackbar();

  ///Table Data ----
  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      maxWidth: 221,
      fontSize: "12px",
      padding: "8px 12px",
    },
  }));

  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openAddRule, setOpenAddRule] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const [ruledescError, setruledescError] = useState(false);
  const [ruleNameError, setruleNameError] = useState(false);
  const [priorityError, setproiorityError] = useState(false);
  const [payScaleTypeAddError, setpayScaleTypeAddError] = useState(false);
  const [ruleNameEditError, setruleNameEditError] = useState(false);
  const [priorityEditError, setpriorityEditError] = useState(false);
  const [ruleDescEditError, setruleDescEditError] = useState(false);

  const [initValNameEdit, setInitValNameEdit] = useState("");
  const [initValDescEdit, setInitValDescEdit] = useState("");
  const [initValPriorityEdit, setInitPriorityEdit] = useState("");
  const [enableEditBtn, setEnableEdit] = useState(true);
  const [delRuleId, setDelRuleId] = useState("");
  const [continueDeleteBtn, setContinueDeleteBtn] = useState(false);

  const [confirmationUpdateMessage, setUpdateConfirmationMessage] =
    useState("");
  const [continueUpdateBtn, setContinueUpdateBtn] = useState(false);
  const [pendingUpdatePayload, setPendingUpdatePayload] = useState<any>(null);
  const [confirmationUpdateOpen, setConfirmationUpdateOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenEdit = (row: any) => {
    setOpenEdit(true);
    setEnableEdit(true);
    setPayscaleTypeEdit(row.payscale_type);
    setRuleDescEdit(row.rule_description);
    setRuleIdEdit(row.rule_id);
    setInitValDescEdit(row.rule_description);
    setRuleNameEdit(row.rule_name);
    setInitValNameEdit(row.rule_name);
    setRuleNumberEdit(row.rule_number);
    setPriorityEdit(row.priority);
    setInitPriorityEdit(row.priority);
  };

  const ruleNameEditModal = (val: any) => {
    setRuleNameEdit(val);
    if (val.trim() != initValNameEdit) {
      setEnableEdit(false);
    }
  };

  const ruleDescEditModal = (val: any) => {
    setRuleDescEdit(val);
    if (val.trim() != initValDescEdit) {
      setEnableEdit(false);
    }
  };

  const rulePriorityEditModal = (val: any) => {
    setPriorityEdit(val);
    if (val.trim() != initValPriorityEdit) {
      setEnableEdit(false);
    }
  };

  const handleUpdateRule = async () => {
    console.log(
      "test",
      payScaleTypeEdit,
      ruleDescEdit,
      ruleNameEdit,
      ruleNumberEdit,
      priorityEdit
    );
    setruleDescEditError(false);
    setruleNameEditError(false);
    setpriorityEditError(false);
    var flag = 0;
    if (ruleDescEdit.trim() == "") {
      setruleDescEditError(true);
      flag = 1;
    }
    if (ruleNameEdit.trim() == "") {
      setruleNameEditError(true);
      flag = 1;
    }
    if (priorityEdit.toString().trim() == "") {
      setpriorityEditError(true);
      flag = 1;
    }

    if (flag == 1) {
      return;
    }

    const payload = {
      payScaleType: payScaleTypeEdit,
      ruleNumber: ruleNumberEdit,
      nameofrule: ruleNameEdit,
      priority: priorityEdit.toString(),
      ruledesc: ruleDescEdit,
      ruleId: ruleIdEdit,
      confirm: null,
      descModifiedFlag:false
    };

    const response = await updateRule(payload);
    showSnackbar(response.message, "success");
    handleCloseEdit();
    if (response.status === "pending_confirmation") {
      setUpdateConfirmationMessage(response.message || "Confirmation required");
      setPendingUpdatePayload({
        ...payload,
        descModifiedFlag: response.descModifiedFlag,
      });
      setConfirmationUpdateOpen(true);
      setContinueUpdateBtn(response.flag);
    } else if (
      typeof response.message === "string" &&
      response.message.includes("Data has been modified successfully")
    ) {
      const tbl_response = await getRules();
      console.log(tbl_response);
      setPayScaleTypes(tbl_response.payScaleType);
      setRuleNumbers(tbl_response.ruleNumber);
      setPayScaleTypeFilter("All");
      setRuleNumberFilter("All");
      setInitialData(tbl_response.data);
      props.setData(tbl_response);
    }
  };

  const handleOpenAddRule = () => {
    setOpenAddRule(true);
    setPayscaleTypeAdd("");
    setRuleNameAdd("");
    setRuleDescAdd("");
    setPriorityAdd("");
  };

  const handleAddRule = async () => {
    setPayScaleError(false);
    setpayScaleTypeAddError(false);
    setruledescError(false);
    setruleNameError(false);
    setproiorityError(false);
    var flag = 0;
    if (payScaleTypeAdd.trim() == "") {
      setpayScaleTypeAddError(true);
      flag = 1;
    }

    if (ruleNameAdd.trim() == "") {
      setruleNameError(true);
      flag = 1;
    }

    if (priorityAdd.trim() == "") {
      setproiorityError(true);
      flag = 1;
    }
    if (ruleDescAdd.trim() == "") {
      setruledescError(true);
      flag = 1;
    }
    if (flag == 1) {
      return;
    }
    const payload = {
      payScaleType: payScaleTypeAdd,
      nameofrule: ruleNameAdd,
      ruledescription: ruleDescAdd,
      priority: priorityAdd,
      confirm: false,
    };

    const response = await addRule(payload);

    console.log(response);
    if (response.status === "pending_confirmation") {
      setConfirmationMessage(response.message || "Confirmation required");
      setPendingPayload(payload);
      setConfirmationOpen(true);
    } else if (
      typeof response.message === "string" &&
      response.message.includes("Rule inserted successfully")
    ) {
      handleCloseAddRule();
      showSnackbar(response.message, "success");
      const tbl_response = await getRules();
      console.log(tbl_response);
      setPayScaleTypes(tbl_response.payScaleType);
      setRuleNumbers(tbl_response.ruleNumber);
      setPayScaleTypeFilter("All");
      setRuleNumberFilter("All");
      setInitialData(tbl_response.data);
      props.setData(tbl_response);
    }
  };
  const handleDeleteRule = async () => {
    console.log("delete", ruleno);

    const payload = {
      payScaleType: delPayScaleType,
      ruleNumber: delRulNo,
      ruleId: delRuleId,
      confirm: null,
    };
    console.log(payload);
    const del_response = await deleteInstruction(payload);
    showSnackbar(del_response.message, "success");
    console.log(del_response);
    handleCloseDelete();
    if (del_response.status === "pending_confirmation") {
      setConfirmationDeleteMessage(
        del_response.message || "Confirmation required"
      );
      setPendingDeletePayload(payload);
      setConfirmationDeleteOpen(true);
      setContinueDeleteBtn(del_response.flag);
    } else if (
      typeof del_response.message === "string" &&
      del_response.message.includes("Data has been modified successfully")
    ) {
      const tbl_response = await getRules();
      console.log(tbl_response);
      setPayScaleTypes(tbl_response.payScaleType);
      setRuleNumbers(tbl_response.ruleNumber);
      setPayScaleTypeFilter("All");
      setRuleNumberFilter("All");
      setInitialData(tbl_response.data);
      props.setData(tbl_response);
    }
  };
  const handleCloseAddRule = () => setOpenAddRule(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleOpenDelete = (row: any) => {
    setOpenDelete(true);
    console.log(row);
    setDelRulNo(row.rule_number);
    setDelPayScaleType(row.payscale_type);
    setDelRuleId(row.rule_id);
  };
  const handleCloseDelete = () => setOpenDelete(false);

  const [payScaleTypeFilter, setPayScaleTypeFilter] = useState("All");
  const [ruleNumberFilter, setRuleNumberFilter] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataMemo, setFilteredDataMemo] = useState([]);
  // Filter and search data
  // const filteredData = useMemo(() => {
  //   return initialData.filter((row:any) => {
  //     const matchPayScale =
  //       payScaleTypeFilter === "All" || row.payScaleType === payScaleTypeFilter;
  //     const matchRuleNumber =
  //       ruleNumberFilter === "All" || row.ruleNumber === ruleNumberFilter;
  //     const matchSearch =
  //       searchText === "" ||
  //       row.description.toLowerCase().includes(searchText.toLowerCase()) ||
  //       row.ruleNumber.toLowerCase().includes(searchText.toLowerCase()) ||
  //       row.name.toLowerCase().includes(searchText.toLowerCase()) ||
  //       row.payScaleType.toLowerCase().includes(searchText.toLowerCase());

  //     return matchPayScale && matchRuleNumber && matchSearch;
  //   });
  // }, [payScaleTypeFilter, ruleNumberFilter, searchText]);

  useEffect(() => {
    const updatedFilteredData = initialData.filter((row: any) => {
      const matchPayScale =
        payScaleTypeFilter === "All" ||
        row.payscale_type === payScaleTypeFilter;
      const matchRuleNumber =
        ruleNumberFilter === "All" || row.rule_number === ruleNumberFilter;
      const matchSearch =
        searchText === "" ||
        row.rule_description.toLowerCase().includes(searchText.toLowerCase()) ||
        row.rule_number.toLowerCase().includes(searchText.toLowerCase()) ||
        row.rule_name.toLowerCase().includes(searchText.toLowerCase()) ||
        row.payscale_type.toLowerCase().includes(searchText.toLowerCase());

      return matchPayScale && matchRuleNumber && matchSearch;
    });

    setFilteredData(updatedFilteredData);
    setFilteredDataMemo(updatedFilteredData);
  }, [initialData, payScaleTypeFilter, ruleNumberFilter, searchText]);

  useEffect(() => {
    setPage(0);
  }, [payScaleTypeFilter, ruleNumberFilter, searchText]);
  // Pagination slice
  const pagedData = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClearFilters = () => {
    setPayScaleTypeFilter("All");
    setRuleNumberFilter("All");
    setSearchText("");
    setPage(0);
  };

  return (
    <>
      <div className="card dark-table">
        <div
          style={{
            paddingTop: "32px",
            color: "#fff",
          }}
        >
          {/* Filters and Search Top Bar */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {/* Category Filter */}
              <FormControl
                sx={{
                  minWidth: 120,
                  "& .MuiInputLabel-root": { color: "#fff" },
                  "& .MuiSelect-select": {
                    color: "#fff",
                    background: "#252628",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "0.8px solid #000",
                  },
                  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "0.8px solid #000",
                    },
                  "& .MuiSelect-icon": { color: "#fff" },
                }}
                size="small"
              >
                <InputLabel id="category-filter-label">
                  Pay scale type
                </InputLabel>
                <Select
                  labelId="pay-type-filter-label"
                  value={payScaleTypeFilter}
                  label="Pay scale type"
                  onChange={(e) => setPayScaleTypeFilter(e.target.value)}
                >
                  <MenuItem key="All" value="All">
                    All
                  </MenuItem>
                  {payScaleTypes.map((paytype: any) => (
                    <MenuItem key={paytype} value={paytype}>
                      {paytype}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Status Filter */}
              <FormControl
                sx={{
                  minWidth: 120,
                  "& .MuiInputLabel-root": { color: "#fff" },
                  "& .MuiSelect-select": {
                    color: "#fff",
                    background: "#252628",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "0.8px solid #000",
                  },
                  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "0.8px solid #000",
                    },
                  "& .MuiSelect-icon": { color: "#fff" },
                }}
                size="small"
              >
                <InputLabel id="rule-number-filter-label">
                  Rule number
                </InputLabel>
                <Select
                  labelId="rule-number-filter-label"
                  value={ruleNumberFilter}
                  label="RuleNumber"
                  onChange={(e) => setRuleNumberFilter(e.target.value)}
                >
                  <MenuItem key="All" value="All">
                    All
                  </MenuItem>
                  {ruleNumbers.map((rno: any) => (
                    <MenuItem key={rno} value={rno}>
                      {rno}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Clear Filters Button */}

              <Button
                variant="outlined"
                color="error"
                onClick={handleClearFilters}
                startIcon={<ClearOutlinedIcon />}
              >
                Clear Filters
              </Button>
            </Box>

            {/* Search Field */}
            <TextField
              size="small"
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{
                minWidth: 200,
                borderRadius: "25px",
                "& label": { color: "#ccc" },
                "& .MuiOutlinedInput-root": {
                  color: "#fff",
                  "& fieldset": {
                    borderColor: "#3C3B3B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#3C3B3B",
                  },
                },
                input: { color: "#fff" },
              }}
            />
          </Box>

          <TableContainer
            sx={{ bgcolor: "#0F1116", borderTop: "none", borderRadius: "8px" }}
          >
            <Table className="manage-rules-tbl">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1C1E22" }}>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                      borderRight: "1px solid #2F3337",
                      width: "8em",
                    }}
                  >
                    Pay scale type
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                      borderRight: "1px solid #2F3337",
                      width: "7em",
                    }}
                  >
                    Rule number
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                      borderRight: "1px solid #2F3337",
                    }}
                  >
                    Name of rule
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                      borderRight: "1px solid #2F3337",
                    }}
                  >
                    Rule description
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                      borderRight: "1px solid #2F3337",
                    }}
                  >
                    Priority
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "14px",
                      borderBottom: "none",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pagedData.map((row: any, index: number) => (
                  <TableRow
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#26292E" : "#1C1E22",
                    }}
                  >
                    <TableCell
                      sx={{
                        color: "#BFC1C2",
                        fontWeight: 400,
                        fontSize: "16px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      {row.payscale_type}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#BFC1C2",
                        fontWeight: 400,
                        fontSize: "16px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      {row.rule_number}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#BFC1C2",
                        fontWeight: 400,
                        fontSize: "16px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      {row.rule_name}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#BFC1C2",
                        fontWeight: 400,
                        fontSize: "16px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {row.rule_description}&nbsp;
                        <BootstrapTooltip
                          title={
                            <div style={{ marginBottom: "1em" }}>
                              <h4 style={{ marginBottom: "2px" }}>
                                LLM Interpretation:
                              </h4>
                              {row.explanation}
                              <br />
                              <h4 style={{ marginBottom: "2px" }}>
                                Calculation:
                              </h4>
                              {row.updated_calculation_expression}
                            </div>
                          }
                        >
                          <IconButton
                            color="info"
                            size="small"
                            sx={{ justifyContent: "flex-end" }}
                          >
                            <img src="./icons/info.svg" />
                          </IconButton>
                        </BootstrapTooltip>
                      </div>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#BFC1C2",
                        fontWeight: 400,
                        fontSize: "16px",
                        borderBottom: "none",
                        borderRight: "1px solid #2F3337",
                      }}
                    >
                      {row.priority}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        borderBottom: "none",
                        display: "flex",
                      }}
                      align="center"
                    >
                      <BootstrapTooltip title="Edit">
                        <IconButton
                          onClick={() => handleOpenEdit(row)}
                          color="primary"
                          size="small"
                        >
                          <img src="./icons/edit.svg" />
                        </IconButton>
                      </BootstrapTooltip>
                      <BootstrapTooltip title="Delete">
                        <IconButton
                          onClick={() => handleOpenDelete(row)}
                          color="error"
                          size="small"
                        >
                          <img src="./icons/delete.svg" />
                        </IconButton>
                      </BootstrapTooltip>

                      {row.warning != "NA" && undefined != row.warning && (
                        <BootstrapTooltip
                          title={row.warning}
                          style={{ flex: "1" }}
                        >
                          <IconButton color="error" size="small">
                            <img src="./icons/warning.svg" />
                          </IconButton>
                        </BootstrapTooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      align="center"
                      sx={{ color: "#aaa" }}
                    >
                      No records found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow sx={{ borderBottom: "none" }}>
                  <TablePagination
                    sx={{
                      color: "#fff",
                      borderBottom: "none",
                      "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .css-h7cjts-MuiButtonBase-root-MuiIconButton-root.Mui-disabled":
                        { color: "#fff" },
                      "& .MuiIconButton-root": { color: "#fff" },
                      "& .MuiSelect-select": { color: "#fff" },
                      alignItems: "center",
                    }}
                    rowsPerPageOptions={[5, 10, 25]}
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Rows per page"
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} of ${count}`
                    }
                    showFirstButton
                    showLastButton
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>

        <div className="flex flex-end" style={{ paddingTop: "16px" }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleOpenAddRule}
            sx={{
              textTransform: "none",
              color: "#007CB0",
              borderColor: "#007CB0",
            }}
          >
            Add Rules
          </Button>
        </div>
      </div>
      <Modal
        open={openEdit}
        onClose={handleCloseEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-form w-610">
          <div className="flex" style={{ borderBottom: "1px solid #545C64" }}>
            <Typography
              id="modal-modal-title"
              sx={{
                fontWeight: 600,
                fontSize: "17px",
                mb: "20px",
                color: "#BFC1C2",
                fontFamily: "Inter",
                display: "flex",
                alignItems: "start",
              }}
              variant="h6"
              component="h2"
            >
              <img src="./icons/edit.svg" />
              &nbsp;Edit {ruleNumberEdit}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseEdit}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <ClearOutlinedIcon />
            </IconButton>
          </div>
          <div className="modal-modal-description">
            <div className="popup-input-div" style={{ marginTop: "20px" }}>
              <label htmlFor="payScaleType">Pay scale type</label>
              <InputText
                type="text"
                id="payScaleType"
                className="popup-form-input p-inputtext-sm"
                disabled
                value={payScaleTypeEdit}
                onChange={(e) => setPayscaleTypeEdit(e.target.value)}
              />
            </div>
            <div className="popup-input-div">
              <label htmlFor="payScaleType">Rule number</label>
              <InputText
                type="text"
                id="payScaleType"
                disabled
                className="popup-form-input p-inputtext-sm"
                value={ruleNumberEdit}
                onChange={(e) => setRuleNumberEdit(e.target.value)}
              />
            </div>
            <div className="popup-input-div">
              <label htmlFor="payScaleType">Name of rule</label>
              <InputText
                type="text"
                id="payScaleType"
                className="popup-form-input p-inputtext-sm"
                value={ruleNameEdit}
                onChange={(e) => ruleNameEditModal(e.target.value)}
              />
              {ruleNameEditError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter Rule name
                </small>
              )}
            </div>
            <div className="popup-input-div">
              <label htmlFor="payScaleType">Priority</label>
              <InputText
                type="text"
                id="priority"
                className="popup-form-input p-inputtext-sm"
                value={priorityEdit}
                onChange={(e) => rulePriorityEditModal(e.target.value)}
              />
              {priorityEditError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter priority
                </small>
              )}
            </div>

            <div className="popup-input-div">
              <label htmlFor="ruleDesc">Rule Description</label>
              <InputTextarea
                value={ruleDescEdit}
                id="ruleDesc"
                className="popup-form-input"
                onChange={(e) => ruleDescEditModal(e.target.value)}
                rows={3}
              />
              {ruleDescEditError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter rule description
                </small>
              )}
            </div>
            <div className="flex flex-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={enableEditBtn}
                onClick={() => {
                  handleUpdateRule();
                }}
                sx={{
                  mt: "20px",
                  fontFamily: "Inter",
                  textTransform: "none",
                  padding: "10px 16px",
                  fontSize: "14px",
                  width: "168px",
                  textAlign: "right",
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openAddRule}
        onClose={handleCloseAddRule}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-form w-610">
          <div className="flex" style={{ borderBottom: "1px solid #545C64" }}>
            <Typography
              id="modal-modal-title"
              sx={{
                fontWeight: 600,
                fontSize: "17px",
                mb: "20px",
                color: "#BFC1C2",
                fontFamily: "Inter",
                display: "flex",
                alignItems: "center",
              }}
              variant="h6"
              component="h2"
            >
              <img src="./icons/addicon.svg" />
              &nbsp;Add Rule
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseAddRule}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <ClearOutlinedIcon />
            </IconButton>
          </div>
          <div className="modal-modal-description">
            <div className="popup-input-div" style={{ marginTop: "20px" }}>
              <label htmlFor="payScaleType">Pay scale type</label>
              <InputText
                type="text"
                id="payScaleType"
                className="popup-form-input p-inputtext-sm"
                placeholder="Enter the type of pay scale (e.g. Nurse, Doctor)"
                value={payScaleTypeAdd}
                onChange={(e) => setPayscaleTypeAdd(e.target.value)}
                style={{
                  border: payScaleError ? "2px solid #f44336" : "",
                }}
              />
              {payScaleTypeAddError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter Pay scale type
                </small>
              )}
              {payScaleError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please correct Pay Scale Type.
                </small>
              )}
            </div>
            <div className="popup-input-div">
              <label htmlFor="ruleNumber">Rule number</label>
              <InputText
                type="text"
                id="ruleNumber"
                disabled
                className="popup-form-input p-inputtext-sm"
                placeholder="Rule number will be auto assigned "
              />
            </div>
            <div className="popup-input-div">
              <label htmlFor="ruleName">Name of rule</label>
              <InputText
                type="text"
                id="ruleName"
                className="popup-form-input p-inputtext-sm"
                placeholder="Provide a short, descriptive name for the rule"
                value={ruleNameAdd}
                onChange={(e) => setRuleNameAdd(e.target.value)}
              />
              {ruleNameError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter Rule name
                </small>
              )}
            </div>
            <div className="popup-input-div">
              <label htmlFor="payScaleType">Priority</label>
              <InputText
                type="text"
                id="priority"
                placeholder="Provide Priority for the rule (e.g. 1, 2, 3..)"
                className="popup-form-input p-inputtext-sm"
                value={priorityAdd}
                onChange={(e) => setPriorityAdd(e.target.value)}
              />
              {priorityError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter priority
                </small>
              )}
            </div>
            <div className="popup-input-div">
              <label htmlFor="ruleDesc">Rule Description</label>
              <InputTextarea
                value={ruleDescAdd}
                id="ruleDesc"
                className="popup-form-input"
                placeholder="Describe the rule in detail, including conditions and applicability"
                onChange={(e) => setRuleDescAdd(e.target.value)}
                rows={3}
              />
              {ruledescError && (
                <small style={{ color: "#f44336", fontSize: "0.8rem" }}>
                  Please enter rule description
                </small>
              )}
            </div>
            <div className="flex flex-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => {
                  handleAddRule();
                }}
                sx={{
                  mt: "20px",
                  fontFamily: "Inter",
                  textTransform: "none",
                  padding: "10px 16px",
                  fontSize: "14px",
                  width: "168px",
                  textAlign: "right",
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-form w-610">
          <div className="flex">
            <Typography
              id="modal-modal-title"
              sx={{
                fontWeight: 600,
                fontSize: "17px",
                mb: "20px",
                color: "#BFC1C2",
                fontFamily: "Inter",
                display: "flex",
                alignItems: "start",
              }}
              variant="h6"
              component="h2"
            >
              <img src="./icons/delete.svg" />
              &nbsp;Are you sure you want to delete?
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseDelete}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <ClearOutlinedIcon />
            </IconButton>
          </div>

          <Typography
            id="modal-modal-description"
            sx={{
              mt: 0,
              fontWeight: 400,
              fontSize: "16px",
              color: "#BFC1C2",
              fontFamily: "Open Sans",
            }}
          >
            <input type="hidden" value={ruleno} name="ruleno" />
            This row will be deleted permenantly
          </Typography>
          <div className="flex flex-end">
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseDelete}
              sx={{
                mt: "20px",
                mr: "20px",
                fontFamily: "Inter",
                textTransform: "none",
                padding: "10px 16px",
                fontSize: "14px",
                width: "168px",
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                handleDeleteRule();
              }}
              sx={{
                mt: "20px",
                fontFamily: "Inter",
                textTransform: "none",
                padding: "10px 16px",
                fontSize: "14px",
                width: "168px",
              }}
            >
              Delete
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={confirmationDeleteOpen}
        onClose={() => setConfirmationDeleteOpen(false)}
      >
        <Box
          className="popup-form"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#26292E",
            color: "#fff",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: 400,
          }}
        >
          <h2 className="popup-form-title">Confirmation Required</h2>
          <p>{confirmationDeleteMessage}</p>

          <div
            className="popup-form-actions"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setConfirmationDeleteOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                textTransform: "none",
                "&:hover": { backgroundColor: "#115293" },
              }}
              onClick={async () => {
                if (!pendingDeletePayload) return;
                const confirmPayload = {
                  ...pendingDeletePayload,
                  confirm: "confirm",
                };
                const res = await deleteInstruction(confirmPayload);
                setConfirmationDeleteOpen(false);
                showSnackbar(res.message, "success");
                handleCloseDelete();
                const tbl_response = await getRules();
                setPayScaleTypes(tbl_response.payScaleType);
                setRuleNumbers(tbl_response.ruleNumber);
                setPayScaleTypeFilter("All");
                setRuleNumberFilter("All");
                setInitialData(tbl_response.data);
                props.setData(tbl_response);
              }}
            >
              Confirm
            </Button>
            {continueDeleteBtn && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#115293" },
                }}
                onClick={async () => {
                  if (!pendingDeletePayload) return;
                  const confirmPayload = {
                    ...pendingDeletePayload,
                    confirm: "continue",
                  };
                  const res = await deleteInstruction(confirmPayload);
                  setConfirmationDeleteOpen(false);
                  showSnackbar(res.message, "success");
                  handleCloseDelete();
                  const tbl_response = await getRules();
                  setPayScaleTypes(tbl_response.payScaleType);
                  setRuleNumbers(tbl_response.ruleNumber);
                  setPayScaleTypeFilter("All");
                  setRuleNumberFilter("All");
                  setInitialData(tbl_response.data);
                  props.setData(tbl_response);
                }}
              >
                Continue
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      <Modal
        open={confirmationUpdateOpen}
        onClose={() => setConfirmationUpdateOpen(false)}
      >
        <Box
          className="popup-form"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#26292E",
            color: "#fff",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: 400,
          }}
        >
          <h2 className="popup-form-title">Confirmation Required</h2>
          <p>{confirmationUpdateMessage}</p>
          <div
            className="popup-form-actions"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setConfirmationUpdateOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                textTransform: "none",
                "&:hover": { backgroundColor: "#115293" },
              }}
              onClick={async () => {
                if (!pendingUpdatePayload) return;
                const confirmPayload = {
                  ...pendingUpdatePayload,
                  confirm: "confirm",
                };
                const res = await updateRule(confirmPayload);
                setConfirmationUpdateOpen(false);
                showSnackbar(res.message, "success");
                const tbl_response = await getRules();
                setPayScaleTypes(tbl_response.payScaleType);
                setRuleNumbers(tbl_response.ruleNumber);
                setPayScaleTypeFilter("All");
                setRuleNumberFilter("All");
                setInitialData(tbl_response.data);
                props.setData(tbl_response);
              }}
            >
              Confirm
            </Button>
            {continueUpdateBtn && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#115293" },
                }}
                onClick={async () => {
                  if (!pendingUpdatePayload) return;
                  const confirmPayload = {
                    ...pendingUpdatePayload,
                    confirm: "continue",
                  };
                  const res = await updateRule(confirmPayload);
                  setConfirmationUpdateOpen(false);
                  showSnackbar(res.message, "success");
                  const tbl_response = await getRules();
                  setPayScaleTypes(tbl_response.payScaleType);
                  setRuleNumbers(tbl_response.ruleNumber);
                  setPayScaleTypeFilter("All");
                  setRuleNumberFilter("All");
                  setInitialData(tbl_response.data);
                  props.setData(tbl_response);
                }}
              >
                Continue
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      <Modal open={confirmationOpen} onClose={() => setConfirmationOpen(false)}>
        <Box
          className="popup-form"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#26292E",
            color: "#fff",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            minWidth: 400,
          }}
        >
          <h2 className="popup-form-title">Confirmation Required</h2>
          <p>{confirmationMessage}</p>

          <div
            className="popup-form-actions"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                textTransform: "none",
                "&:hover": { backgroundColor: "#115293" },
              }}
              onClick={async () => {
                if (!pendingPayload) return;
                const confirmPayload = { ...pendingPayload, confirm: true };
                const res = await addRule(confirmPayload);
                showSnackbar(res.message, "success");
                setConfirmationOpen(false);
                handleCloseAddRule();
                const tbl_response = await getRules();
                setPayScaleTypes(tbl_response.payScaleType);
                setRuleNumbers(tbl_response.ruleNumber);
                setPayScaleTypeFilter("All");
                setRuleNumberFilter("All");
                setInitialData(tbl_response.data);
                props.setData(tbl_response);
              }}
            >
              Proceed
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                textTransform: "none",
                "&:hover": { backgroundColor: "#115293" },
              }}
              onClick={() => {
                setConfirmationOpen(false);
                setPayScaleError(true);
              }}
            >
              Edit Pay Scale
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ValidationRules;
